import styled from 'styled-components';
import { Alert } from '@landlord-tech/ui-kit-opp';

const SAlert = styled(Alert)`
  &&& {
  }
`;

export default SAlert;
